export default "/images/vendor/flag-icon-css/flags/4x3/fr.svg?81d43a151d8bc64145f25bc3d4cdc02a";